import cx from "classnames";
import { ReactNode } from "react";

type Props = {
  label: ReactNode;
  value: ReactNode;
  className?: string;
  classNameLabel?: string;
  classNameValue?: string;
};

export function CardRow(p: Props) {
  return (
    <div className={cx("App-card-row", p.className)}>
      <div className={cx("label", p.classNameLabel)}>{p.label}</div>
      <div className={cx("value", p.classNameValue)}>{p.value}</div>
    </div>
  );
}
